import React, { useEffect, useRef, useState } from 'react';
import SucursalLogo from '../sucursales/SucursalLogo';

// Selector de sucursal: el botón y la lista muestran logo + nombre de la sucursal
// (un <select> nativo no puede mostrar imágenes).
// Incluye "Todas las sucursales" solo para el administrador (conTodas); el cajero elige entre sus sucursales asignadas.
export default function SucursalSelector({ sucursales, value, onChange, conTodas = true, id = 'sidebar-sucursal' }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const todas = value === 'all';
  const current = sucursales.find(s => s.id === value) || null;
  const options = sucursales.filter(s => s.activo !== false || s.id === value);

  useEffect(() => {
    if (!open) return undefined;
    const onDown = e => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    const onKey = e => { if (e.key === 'Escape') setOpen(false); };
    document.addEventListener('mousedown', onDown);
    document.addEventListener('keydown', onKey);
    return () => { document.removeEventListener('mousedown', onDown); document.removeEventListener('keydown', onKey); };
  }, [open]);

  const pick = id => { onChange(id); setOpen(false); };

  return (
    <div className="sucursal-selector" ref={ref}>
      <button type="button" id={id} className="sucursal-selector-btn" aria-haspopup="listbox" aria-expanded={open} onClick={() => setOpen(v => !v)}>
        {todas ? <span className="sucursal-todas-icono" aria-hidden="true"><i className="bx bx-buildings" /></span>
          : current && <SucursalLogo sucursal={current} size={32} decorative />}
        <span className="sucursal-selector-name">{todas ? 'Todas las sucursales' : current?.nombre || 'Seleccionar sucursal'}</span>
        <i className={`bx ${open ? 'bx-chevron-up' : 'bx-chevron-down'}`} aria-hidden="true" />
      </button>
      {open && (
        <ul className="sucursal-selector-list" role="listbox" aria-labelledby={`${id}-label`}>
          {options.map(s => (
            <li key={s.id} role="option" aria-selected={s.id === value}>
              <button type="button" className={s.id === value ? 'active' : ''} onClick={() => pick(s.id)}>
                <SucursalLogo sucursal={s} size={32} decorative />
                <span>{s.nombre}</span>
              </button>
            </li>
          ))}
          {conTodas && <li role="option" aria-selected={todas}>
            <button type="button" className={todas ? 'active' : ''} onClick={() => pick('all')}>
              <span className="sucursal-todas-icono" aria-hidden="true"><i className="bx bx-buildings" /></span>
              <span>Todas las sucursales</span>
            </button>
          </li>}
        </ul>
      )}
    </div>
  );
}
